import { useRouter } from 'next/router';
import { useMemo } from 'react';

import {
  BASE_PATH_1_QUERY,
  BASE_PATH_2_QUERY,
  BASE_PATH_3_QUERY,
  EDIT_INDEX_QUERY,
  EDUCATION_EXP_QUERY,
  INDUSTRY_SLUG_QUERY,
  JOBTITLE_SLUG_QUERY,
  NEXT_SECTIONS_QUERY,
  RESUME_ID_QUERY,
  SEED_QUERY,
  WORK_EXP_QUERY,
} from '@glass/common/modules/pages/queryParams';
import removeEmptyKeys from '@glass/common/modules/utils/removeEmptyKeys';
import useBuilderBasePath from '@glass/web/modules/resumes/router/resumeBuilderBasePath/useBuilderBasePath';
import {
  SectionStepWithQuery,
  isValidBuilderSectionStep,
} from '@glass/web/modules/resumes/router/stepData';

// these are the query params that are important
const useBuilderStepParams = ({
  [BASE_PATH_2_QUERY]: section,
  [BASE_PATH_3_QUERY]: step,
}: SectionStepWithQuery) => {
  const defaultResumeBuilderBasePath = useBuilderBasePath();
  const {
    query: {
      [BASE_PATH_1_QUERY]: basePath = defaultResumeBuilderBasePath,
      [RESUME_ID_QUERY]: resumeId,
      [EDIT_INDEX_QUERY]: eIdx,
      [EDUCATION_EXP_QUERY]: educationExp,
      [WORK_EXP_QUERY]: workExp,
      [INDUSTRY_SLUG_QUERY]: industrySlug,
      [JOBTITLE_SLUG_QUERY]: jobTitleSlug,
      [NEXT_SECTIONS_QUERY]: nextSection,
      [SEED_QUERY]: seed,
    },
  } = useRouter();

  return useMemo(() => {
    if (!isValidBuilderSectionStep({ [BASE_PATH_2_QUERY]: section, [BASE_PATH_3_QUERY]: step })) {
      return {};
    }
    return removeEmptyKeys({
      [BASE_PATH_1_QUERY]: basePath,
      [BASE_PATH_2_QUERY]: section,
      [BASE_PATH_3_QUERY]: step,
      [RESUME_ID_QUERY]: resumeId,
      [EDIT_INDEX_QUERY]: eIdx,
      [EDUCATION_EXP_QUERY]: educationExp,
      [WORK_EXP_QUERY]: workExp,
      [INDUSTRY_SLUG_QUERY]: industrySlug,
      [JOBTITLE_SLUG_QUERY]: jobTitleSlug,
      [NEXT_SECTIONS_QUERY]: nextSection,
      [SEED_QUERY]: seed,
    });
  }, [
    basePath,
    section,
    step,
    resumeId,
    eIdx,
    educationExp,
    workExp,
    industrySlug,
    jobTitleSlug,
    nextSection,
    seed,
  ]);
};

export default useBuilderStepParams;
